// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.

import * as Core from "./core.js";

export class APIResource {
  protected _client: Core.APIClient;

  constructor(client: Core.APIClient) {
    this._client = client;
  }
}
